import { AlertMessage } from './alert-message.class';

export class AlertSuccess extends AlertMessage {
  readonly icon: string = 'circle-check';
  readonly type: string = 'success';

  constructor(code: string, title: string, message: string) {
    super(code, title, message);
  }
}
